import { gql } from 'apollo-angular';

export const GET_VOICE_WATCH_DASHBOARD = gql`
  query ($criteria: VoiceWatchDashboardCriteria!) {
    voiceWatchDashboard(criteria: $criteria) {
      url
    }
  }
`;
